module.exports = __webpack_public_path__ + "static/img/全民营销-1.2f553fb0.png";